// @ts-nocheck
import { pxToRem } from "@toolkit/Framework/Common/Utilities/unitHelper";
import Styleguide from "@toolkit/Framework/Types/Styleguide";

const shadows: Styleguide["shadows"] = {
    small: `0 0 ${pxToRem(1)} 0 rgba(48,49,51,0.05), 0 ${pxToRem(2)} ${pxToRem(4)} 0 rgba(48,49,51,0.1)}`,
    main: ` 0 0 ${pxToRem(1)} 0 rgba(52, 52, 52, 0.05), 0 ${pxToRem(8)} ${pxToRem(16)} 0  rgba(52, 52, 52, 0.1)}`,
    alt: `0px 0px ${pxToRem(1)} 0px rgba(48, 49, 51, 0.05), 0px ${pxToRem(16)} ${pxToRem(
        24,
    )} 0px rgba(48, 49, 51, 0.1)`,
};

export default shadows;
